import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { BankAccount, BankAccountInput } from "@/interfaces/talk2pay.iterfaces";
import t2payService from "@/services/t2pay.service";
import { RequestsProps } from "@/types/requests.types";

export type Props = {
  formData: BankAccountInput;
} & RequestsProps;

export type Return = {
  create: (props: Props) => Promise<BankAccount>;
} & UseLoadingReturn;

const useCreateBankAccount = (): Return => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<BankAccountInput>({
    operation: (formData) => t2payService.createBankAccount(formData),
  });

  return { isLoading, startLoading, endLoading, loadingIcon, create };
};

export default useCreateBankAccount;
